import { render, staticRenderFns } from "./RegisterDigiBoard.vue?vue&type=template&id=2c026579&scoped=true"
import script from "./RegisterDigiBoard.vue?vue&type=script&lang=js"
export * from "./RegisterDigiBoard.vue?vue&type=script&lang=js"
import style0 from "./RegisterDigiBoard.vue?vue&type=style&index=0&id=2c026579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c026579",
  null
  
)

export default component.exports